export default __webpack_public_path__ + "static/media/1294.92061c7f.png";